module.exports = __webpack_public_path__ + "img/RS_TV_Streamer_white_rectangular.dbdb595b9e92b977f4231011522810f5.png";